var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import H5 from '../../typography/H5';
import Button from '../../atoms/Button';
import { colors, spacing } from '../../../defaultTheme';
import query from '../../../const/mediaQueries';
import { sharedElementStyles } from './subcomponents';
const CustomTitle = styled(H5) `
  line-height: 32px;
`;
const CustomHeader = styled.div `
  justify-content: space-between;
  min-height: 56px;
  flex-direction: row;
  background: ${colors.lightestGrey};
  border-bottom: 1px solid ${colors.lightGrey};
  box-sizing: border-box;
  ${sharedElementStyles}

  @media ${query.greaterThanMedium} {
    padding: 0px 24px;
  }
`;
const CloseButton = styled(Button) `
  margin: 0;
  padding: ${spacing.small}px;
  border-radius: 50%;
  width: ${spacing.xlarge}px;
  height: ${spacing.xlarge}px;
  &:hover {
    background: ${colors.grey};
  }
  &:active {
    border: 0.5px solid ${colors.heavyGrey};
  }
`;
const CloseIcon = styled(FontAwesomeIcon) `
  font-size: 1.6rem;
  color: ${colors.black};
`;
const ModalHeader = (_a) => {
    var { hideClose, closeModal, content, className, headerRef, closeButtonAriaLabel = 'Close Dialog', dataType, dataTitle, dataReason } = _a, props = __rest(_a, ["hideClose", "closeModal", "content", "className", "headerRef", "closeButtonAriaLabel", "dataType", "dataTitle", "dataReason"]);
    return (_jsxs(CustomHeader, Object.assign({ className: className }, props, { children: [_jsx(CustomTitle, Object.assign({ as: "h1", weight: "bold", tabIndex: -1, ref: headerRef }, { children: content })), !hideClose && (_jsx(CloseButton, Object.assign({ alt: "close", "data-analytics": "clicktrackingevent", "data-type": dataType, "data-title": dataTitle, "data-reason": dataReason, "data-object": "button", className: dataType && 'ensightencustomevent', buttonType: "text", ariaLabel: closeButtonAriaLabel, onClick: () => closeModal && closeModal() }, { children: _jsx(CloseIcon, { icon: faTimes }) })))] })));
};
export default ModalHeader;
//# sourceMappingURL=Header.js.map